import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Tippy from '@tippyjs/react';
import SearchFilters from './searchFilters';

// added generic error message
const errorMessage = (heading, errorsObj, message) => (
  <div>
    <div className="heading">
      { heading }
    </div>
    <div className="message">
      <ul>
        {
          Object.entries(errorsObj).map(([key, value]) =>
            (<li key={key}>
              <div>
                {!!key.length && isNaN(key) ? `${key}` : ''}
              </div>
              <div>
                {value}
              </div>
            </li>),
          )
        }
      </ul>
      { message }
    </div>
  </div>
);


function HeaderSubRow({
  search, uiDateFilter, errorsObj, isJurisdiction,
}) {
  const numErrors = Object.values(errorsObj).length;
  const errorType = isJurisdiction ? 'search' : 'source';
  const errorHeading = isJurisdiction ? `There is temporarily incomplete data due to the following issue${numErrors > 1 ? 's' : ''}` : `Results may be incomplete for the following source${numErrors > 1 ? 's' : ''}`;
  const message = isJurisdiction ? '' : `We're sorry, we could not process the search for the source${numErrors > 1 ? 's' : ''} at this time`; // generic error message for Search By Contributor
  return (
    <div className="search-header-sub-row">
      <div className="results-details-row">
        <SearchFilters
          search={search}
          uiDateFilter={uiDateFilter}
        />
        {numErrors > 0 ?
          <Tippy
            content={errorMessage(errorHeading, errorsObj, message)} // passing the generic error message here
          >
            <span className="errors-wrapper">
              <span className="errors">
                <i className="material-icons">info</i>
                {numErrors} {pluralize(errorType, numErrors)} had errors
              </span>
            </span>
          </Tippy>
          : null}
      </div>
    </div>
  );
}


HeaderSubRow.propTypes = {
  search: PropTypes.object.isRequired,
  uiDateFilter: PropTypes.object, // only in research view
  errorsObj: PropTypes.object.isRequired,
  isJurisdiction: PropTypes.bool,
};

HeaderSubRow.defaultProps = {
  uiDateFilter: {},
  isJurisdiction: false,
};

export default HeaderSubRow;
